import React, { useState } from "react";
import {
  CardSelected,
  MultiSelectConditionType,
  MultiSelectLanguageType,
  StatsDataType,
} from "../../../type";
import { ContainerStyled } from "./LeftSideMenuUploadCards.styled";
import { PrimaryButton } from "../../common/common.style";
import { ModalAddCtToken } from "./ModalAddCtToken";
import { ModalChangeDefaultValue } from "./ModalChangeDefaultValue";
import { FilterV2 } from "../../Filters/FilterV2";
import { SubHeader } from "../SubHeader/SubHeader";
import { FlexBox } from "../../primitives";

interface CardSearchProps {
  setDefaultStatsValue: (arg1: StatsDataType) => void;
  defaultStatsValue: StatsDataType;
  filterOption: string;
  sortOption: string;
  searchText: string;
  setFilterOption: React.Dispatch<React.SetStateAction<string>>;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  setSortOption: React.Dispatch<React.SetStateAction<string>>;
  priceMin?: number;
  priceMax?: number;
  setPriceMin: (arg1: number) => void;
  setPriceMax: (arg1: number) => void;
  cardsBoard: CardSelected[];
  hasFailedCards: boolean;
  setLanguagesFilter: (arg1: MultiSelectLanguageType[]) => void;
  setConditionsFilter: (arg1: MultiSelectConditionType[]) => void;
  languagesFilter: MultiSelectLanguageType[];
  conditionsFilter: MultiSelectConditionType[];
  setSearchTextComment: (arg1: string) => void;
  searchTextComment: string;
}

export const LeftSideMenuUploadCards = ({
  setDefaultStatsValue,
  defaultStatsValue,
  setSortOption,
  sortOption,
  searchText,
  filterOption = "none",
  setSearchText,
  setFilterOption,
  priceMin,
  priceMax,
  setPriceMin,
  setPriceMax,
  cardsBoard,
  hasFailedCards,
  setLanguagesFilter,
  setConditionsFilter,
  languagesFilter,
  conditionsFilter,
  searchTextComment,
  setSearchTextComment,
}: CardSearchProps) => {
  const [isOpenAddTokenModal, setIsOpenAddTokenModal] = useState(false);
  const [isOpenModalDefaultValue, setIsOpenModalDefaultValue] = useState(false);
  // const token = useSelector(selectToken);

  return (
    <>
      {isOpenAddTokenModal && (
        <ModalAddCtToken setIsOpenAddTokenModal={setIsOpenAddTokenModal} />
      )}
      {isOpenModalDefaultValue && (
        <ModalChangeDefaultValue
          setIsOpenModalDefaultValue={setIsOpenModalDefaultValue}
          setDefaultStatsValue={setDefaultStatsValue}
          defaultStatsValue={defaultStatsValue}
        />
      )}
      <ContainerStyled>
        <FlexBox css={{ justifyContent: "center" }}>
          <PrimaryButton
            onClick={() => setIsOpenModalDefaultValue(true)}
            css={{ width: 120 }}
          >
            Change Default value
          </PrimaryButton>
        </FlexBox>
        {/* <SecondaryButton onClick={() => setIsOpenAddTokenModal(true)}>
          {token ? "TOKEN ADDED" : "ADD CT TOKEN"}
        </SecondaryButton> */}
        <SubHeader cardsBoard={cardsBoard} hasFailedCards={hasFailedCards} />
        <FilterV2
          setSortOption={setSortOption}
          sortOption={sortOption}
          searchText={searchText}
          setSearchText={setSearchText}
          priceMin={priceMin}
          priceMax={priceMax}
          setPriceMin={setPriceMin}
          setPriceMax={setPriceMax}
          filterOption={filterOption}
          setFilterOption={setFilterOption}
          setLanguagesFilter={setLanguagesFilter}
          setConditionsFilter={setConditionsFilter}
          languagesFilter={languagesFilter}
          conditionsFilter={conditionsFilter}
          searchTextComment={searchTextComment}
          setSearchTextComment={setSearchTextComment}
        />
      </ContainerStyled>
    </>
  );
};
